var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubjectArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,52a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V53A1,1,0,0,0,24,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,52a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V53A1,1,0,0,0,40,52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.122,40.122a3.006,3.006,0,0,1-4.244,0,1,1,0,0,0-1.414,1.414,5.007,5.007,0,0,0,7.072,0,1,1,0,0,0-1.414-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,45H37.644A8.983,8.983,0,0,0,41,38V28a5.006,5.006,0,0,0-5-5H21a1,1,0,0,0-1,1v3a4,4,0,0,0,4,4h9a1,1,0,0,0,0-2H24a2,2,0,0,1-2-2V25H36a3,3,0,0,1,3,3v1H37a1,1,0,0,0,0,2h2v7a7,7,0,0,1-14,0V34a1,1,0,0,0-2,0v4a8.983,8.983,0,0,0,3.356,7H24a7.008,7.008,0,0,0-7,7v9a1,1,0,0,0,2,0V52a5.006,5.006,0,0,1,5-5h3.465L31,52.3V61a1,1,0,0,0,2,0V52.3L36.535,47H40a5.006,5.006,0,0,1,5,5v9a1,1,0,0,0,2,0V52A7.008,7.008,0,0,0,40,45Zm-5.655,1.679-2.229,3.344A1.133,1.133,0,0,0,32,50a1.133,1.133,0,0,0-.116.023l-2.229-3.344a8.726,8.726,0,0,0,4.69,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,24H60a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H48a1,1,0,0,1,0-2H60a1,1,0,0,0,0-2H48a3,3,0,0,0-3,3V21A3,3,0,0,0,48,24ZM48,8H59V22H48a1,1,0,0,1-1-1V7.816A2.966,2.966,0,0,0,48,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,20h2a2.987,2.987,0,0,0,2.22-5A2.987,2.987,0,0,0,53,10H51a1,1,0,0,0-1,1v8A1,1,0,0,0,51,20Zm2-2H52V16h1a1,1,0,0,1,0,2Zm-1-6h1a1,1,0,0,1,0,2H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,16H32v1a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V15a2.994,2.994,0,0,0-1.4-2.529A2.959,2.959,0,0,0,37,8.184V3a1,1,0,0,0-1-1H22a1,1,0,0,0-1,1V15A1,1,0,0,0,22,16Zm13-5a1,1,0,1,1,1,1A1,1,0,0,1,35,11Zm3,5H34V15a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1ZM23,4H35V8.184a2.959,2.959,0,0,0-1.6,4.287A3,3,0,0,0,32.184,14H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,8h2a1,1,0,0,0,0-2H28a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10H26a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,42V32a3,3,0,0,0-3-3H5a3,3,0,0,0-3,3V42a3,3,0,0,0,3,3h6A3,3,0,0,0,14,42ZM4,42V32a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1V42a1,1,0,0,1-1,1H5A1,1,0,0,1,4,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,39H7a1,1,0,0,0,0,2H9a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,40H60V34a3,3,0,0,0-3-3H49a3,3,0,0,0-3,3v3a1,1,0,0,0,2,0V34a1,1,0,0,1,1-1h1.551l6.222,7H45a1,1,0,0,0-1,1v2a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V41A1,1,0,0,0,61,40Zm-4-7a1,1,0,0,1,1,1v4.369L53.227,33Zm3,10a1,1,0,0,1-1,1H47a1,1,0,0,1-1-1V42H60Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 26,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,55H12a3,3,0,0,1-3-3V48a1,1,0,0,0-2,0v4a5.006,5.006,0,0,0,5,5h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,49a1,1,0,0,0-1,1v2a3,3,0,0,1-3,3H50a1,1,0,0,0,0,2h2a5.006,5.006,0,0,0,5-5V50A1,1,0,0,0,56,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.447,10.605A1,1,0,0,0,7,11.5v5a1,1,0,0,0,1.447.895l5-2.5a1,1,0,0,0,0-1.79ZM9,14.882V13.118L10.764,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14a8,8,0,1,0-4.193,7.038,1,1,0,0,0-.953-1.759,6,6,0,1,1,2.425-2.425,1,1,0,0,0,1.759.953A8.023,8.023,0,0,0,18,14Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectArea);
export default __webpack_public_path__ + "static/media/subject-area.f0130d9297ec0d18d42ec67ce0c2cd2c.svg";
export { ForwardRef as ReactComponent };